import { render } from "./AppInicio.vue?vue&type=template&id=25d9fd78&scoped=true"
import script from "./AppInicio.vue?vue&type=script&lang=js"
export * from "./AppInicio.vue?vue&type=script&lang=js"

import "./AppInicio.vue?vue&type=style&index=0&id=25d9fd78&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d9fd78"]])

export default __exports__